import contentEditable from '../../content-editable';
import proxyMouseUpToParentContext from '../utils/helpers/proxy-mouseup-to-parent-context';

const documentMouseUpHandler = (event) => {
  const { srcElement } = event;

  if (srcElement && srcElement.closest) {
    const isContentEditable = srcElement.closest('[contenteditable]');

    if (isContentEditable) {
      contentEditable.helpers.handleAdjacentNode();
    }
  }

  proxyMouseUpToParentContext(event);
};

export default documentMouseUpHandler;
